import _ from 'lodash';
import { Service } from 'pdk/services';
import AppConfig from '@/config';
import http, { kendoBeforeSend } from './http';


export class GroupService extends Service {
	// CTOR
    constructor(httpService) {
        super();

        this.http = httpService || http;
    }


    // Groups
    createGroup(options) {
        const data = this._extend(options, {
            name: null,
            reportName: null
        });

        return this.http.post(`locationgroups`, data)
            .then((response) => response.data);
    }
    deleteGroup(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        return this.http.delete(`locationgroups/${data.locationGroupID}`)
            .then((response) => response.data);
    }
    getGroup(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        return this.http.get(`locationgroups/${data.locationGroupID}`)
            .then((response) => response.data && response.data.length ? response.data[0] : null);
    }
    getGroups() {
        return this.http.get('locationgroups')
            .then((response) => response.data);
    }
    updateGroupIcon(options) {
        const data = this._extend(options, {
            locationGroupID: null,
            iconImage: null,
            iconText: null,
            iconBackgroundColor: null,
            iconTextColor: null
        });

        return this.http.put(`locationgroups/${data.locationGroupID}/icon`, _.omit(data, ['locationGroupID']))
            .then((response) => response.data);
    }

	// Users
    addUser(options) {
        const data = this._extend(options, {
            locationGroupID: null,
            requests: []
        });

        return this.http.put(`locationgroups/${data.locationGroupID}/users`, data.requests);
    }
    getLocationGroupUserPermissions(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        return this.http.get(`locationgroups/${data.locationGroupID}/permissions`);
    }
    getUsers_KendoDataSource(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        var baseURL = AppConfig.api.baseURL || '/api';
        return {
            transport: {
                read: {
                    url: `${baseURL}/locationgroups/${data.locationGroupID}/users`,
                    type: 'POST',
                    beforeSend: kendoBeforeSend
                },
                parameterMap: function (data, type) {
                    if (data.filter != null) {
                        data.filter.filters.forEach((x) => {
                            if (x.field == "lastLoginOn") {
                                var dt = `${x.value.getMonth()+1}-${x.value.getDate()}-${x.value.getFullYear()}`;
                                x.value = dt;
                            }
                        });
                    }
                    return data;
                },
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'users',
                model: {
                    id: 'globalUserID',
                    fields: {
                        userName: { type: 'string', nullable: false },
                        firstName: { type: 'string', nullable: false },
                        lastName: { type: 'string', nullable: false },
                        role: { type: 'number', nullable: false },
                        emailAddress: { type: 'string', nullable: false },
                        lastLoginOn: { type: 'date', nullable: true }
                    }
                }
            }
        };
    }
    removeUser(options) {
        const data = this._extend(options, {
            globalUserID: null,
            locationGroupID: null
        });

        return this.http.delete(`locationgroups/${data.locationGroupID}/users/${data.globalUserID}`);
    }

    // Candidates
    getCandidates_KendoDataSource(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        var baseURL = AppConfig.api.baseURL || '/api';
        return {
            transport: {
                read: {
                    url: `${baseURL}/locationgroups/${data.locationGroupID}/candidates`,
                    type: 'POST',
                    beforeSend: kendoBeforeSend
                }
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'users',
                model: {
                    id: 'globalUserID',
                    fields: {
                        userName: { type: 'string' },
                        firstName: { type: 'string' },
                        lastName: { type: 'string' },
                        emailAddress: { type: 'string' },
                        lastLoginOn: { type: 'date' }
                    }
                }
            }
        };
    }

    // Dashboards
    getDashboards(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        return this.http.get(`locationgroups/${data.locationGroupID}/dashboards`)
            .then((response) => response.data);
    }
    getDashboards_KendoDataSource(options) {
        const data = this._extend(options, {
            locationGroupID: null
        });

        const fn = _.bind(this.getDashboards, this);

        return {
            transport: {
                read(options) {
                    fn({
                        locationGroupID: data.locationGroupID
                    })
                        .then((dashboardList) => {
                            options.success({
                                totalRows: dashboardList.length,
                                data: dashboardList
                            });
                        })
                        .catch((response) => {
                            options.error(response);
                        });
                }
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'data',
                model: {
                    id: 'dashboardID',
                    fields: {
                        dashboardName: { type: 'string', nullable: false },
                        defaultDashboardPermission: { type: 'number', nullable: false },
                        defaultDateRange: { type: 'number', nullable: false },
                        defaultGroupBy: { type: 'number', nullable: false }
                    }
                }
            }
        };
    }
    updateDashboards(options) {
        const data = this._extend(options, {
            locationGroupID: null,
            dashboards: null
        });

        return this.http.put(`locationgroups/${options.locationGroupID}/dashboards`,
            _.map(data.dashboards, (d) => _.pick(d, 'dashboardID', 'defaultDashboardPermission', 'defaultDateRange', 'defaultGroupBy', 'defaultLocationIDs', 'changedOn'))
        );
    }
}

export default new GroupService();
